import { deleteFile } from "../../api/uploadService";

export const useDeleteFile = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteFile(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete file:", error);
            throw error;
        }
    };

    return { remove };
};